import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["updater"];

  connect() {
    this.submitting = false;
    this.updateSavedChanges();
  }

  updaterTargetConnected(updaterTarget) {
    this.updateSavedChanges();
  }

  submit(event) {
    this.submitting = true;
  }

  updateSavedChanges() {
    this.originalFormDataSerialized = this.serializeFormData(this.element);
  }

  unsaved(event) {
    if (this.submitting) return;
    if (!this.hasChanged()) return;

    this.submitting = false;

    event.preventDefault();

    event.returnValue = true;
  }

  unsavedTurbo(event) {
    if (this.submitting) return;
    if (!this.hasChanged()) return;

    this.submitting = false;

    if (window.confirm(this.element.dataset.unsavedChangesConfirmValue)) return;

    event.preventDefault();
  }

  formData(form) {
    const formData = new FormData(form);

    formData.delete("authenticity_token");

    return formData;
  }

  /*
   * Elimina saltos de línea y espacios al serializar, para evitar
   * detectar cambios cuando cambió el espaciado, por ejemplo cuando el
   * editor con formato aplica espacios o elimina saltos de línea.
   */
  serializeFormData(form) {
    return (new URLSearchParams(this.formData(form))).toString().replaceAll("+", "").replaceAll("%0A", "");
  }

  hasChanged() {
    return (this.originalFormDataSerialized !== this.serializeFormData(this.element));
  }
}
